<template>
  <b-container>
    <h1>
      <p>{{ $t('wifi.connectTo') }}</p>
      <p><b>{{ wifi.ssid }}</b></p>
      <!-- <p><b><b-icon-wifi></b-icon-wifi>{{ wifi.ssid }}</b></p> -->
    </h1>
    <b-spinner v-if="isConnecting" />
    <b-container v-else style="max-width: 500px;" class="text-left">
      <b-form-invalid-feedback v-if="errorMsg !== ''" :force-show="true">
        <p>{{$t(errorMsg)}}</p>
      </b-form-invalid-feedback>
      <component
        :is="formComponent"
        v-on:connect="onConnect">
      </component>
    </b-container>
  </b-container>
</template>

<script>
import axios from 'axios';
import axiosRetry from 'axios-retry';
import SetupWifiCredentialsOpen from './SetupWifiCredentialsOpen';
import SetupWifiCredentialsWPA from './SetupWifiCredentialsWPA';
import SetupWifiCredentialsEnterprise from './SetupWifiCredentialsEnterprise';

axiosRetry(axios, { retries: 6 });
axiosRetry(axios, { retryDelay: (retryCount) => {
  return retryCount * 2000;
}});

export default {
  name: 'SetupWifiCredentials',
  props: ['wifi'],
  components: {
    SetupWifiCredentialsOpen,
    SetupWifiCredentialsWPA,
    SetupWifiCredentialsEnterprise,
  },
  data() {
    return {
      isConnecting: false,
      errorMsg: '',
      formComponent: '',
    }
  },
  mounted () {
    if (this.wifi.encryption === 'off') {
      this.formComponent = SetupWifiCredentialsOpen;
    } else if (this.wifi.authentication_suites === '802.1x') {
      this.formComponent = SetupWifiCredentialsEnterprise;
    } else {
      this.formComponent = SetupWifiCredentialsWPA;
    }
  },
  methods: {
    getNetworkStatus() {
      if (this.isConnecting) {
        axios
          .get('http://10.3.141.1:6762/api/v1/network/status')
          .then(response => {
            if (response.status == 200) {
              this.isConnecting = response.data.status == 'connecting';
              if (response.data.status == 'success') {
                this.$emit('connection_success', this.wifi.ssid);
              }
              if (response.data.status == 'error') {
                this.errorMsg = 'wifi.error';
              }
            }
          })
          .catch(error => {
            console.log(error);
            this.$emit('ensure_sensor_is_reachable');
          })
          .finally(() => {
            if (this.isConnecting) {
              setTimeout(() => this.getNetworkStatus(), 1000);
            }
          });
      }
    },
    onConnect(credentials) {
      credentials.ssid = this.wifi.ssid;
      if (this.wifi.scan_ssid) {
        credentials.scan_ssid = this.wifi.scan_ssid;
      }

      const params = new URLSearchParams();
      for (let [key, value] of Object.entries(credentials)) {
        params.append(key, value);
      }

      this.isConnecting = true;
      axios
        .post('http://10.3.141.1:6762/api/v1/networks', params)
        .then(response => {
          if (response.status == 200) {
            this.getNetworkStatus();
          } else {
            this.errorMsg = 'wifi.error';
            this.isConnecting = false;
          }
        }).catch(error => {
          // due to the network switch on the device, an error can occur even if
          // everything works as intended. If getting the network status failes
          // as well, then an error will be displayed
          console.log(error);
          this.getNetworkStatus();
          this.$emit('ensure_sensor_is_reachable');
      });
    }
  }
}
</script>
